import { DashboardPaging } from '../../interfaces/DashboardPaging';
import { dashboardSortKey } from '../../helpers/dashboardHelper';

// Key is [name, ...data set, ...view]. Previous data stays on screen across a
// view change (page, chips, sort, search) and is dropped across a data set
// change (agent, range).
const DATA_SET_FIELDS = 5;

export const dashboardQueryKey = (
  name: string,
  dataSet: {
    companyId?: string;
    userId?: string;
    startDate?: string;
    endDate?: string;
    agentIds?: string;
  },
  paging: DashboardPaging | undefined,
  categories: string[]
): unknown[] => [
  name,
  dataSet.companyId,
  dataSet.userId,
  dataSet.startDate,
  dataSet.endDate,
  dataSet.agentIds,
  paging?.page,
  paging?.pageSize,
  // sorted, so picking the same chips in a different order is one cache entry
  [...categories].sort().join('\u0000'),
  dashboardSortKey(paging?.sort),
  paging?.search?.trim() || undefined,
];

const sameDataSet = (a: readonly unknown[], b: readonly unknown[]) =>
  a.slice(0, 1 + DATA_SET_FIELDS).every((part, index) => part === b[index]);

/** placeholderData: keep the previous answer only within one data set. */
export const keepWhileSameDataSet =
  (queryKey: readonly unknown[]) =>
  (previous: unknown, previousQuery?: { queryKey: readonly unknown[] }) =>
    previousQuery && sameDataSet(previousQuery.queryKey, queryKey)
      ? previous
      : undefined;
